import { useContext } from 'react';
import { FeatureFlagContext } from '@/providers/feature-flag-context';

export function useFeatureFlagsReady() {
  const context = useContext(FeatureFlagContext);

  return context?.isReady ?? true;
}
